// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-Lie","content":"styles_content__1P2lN"};